import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import type { TradeType } from "#/types/trade";

export const perpTradeTypeAtom = atomWithStorage<TradeType>(
  "perpTradeType",
  "market",
);

export const usePerpTradeType = () => {
  const [perpTradeType, setPerpTradeType] = useAtom(perpTradeTypeAtom);

  const isMarket = perpTradeType === "market";
  const isLimit = perpTradeType === "limit";
  const isRFQ = perpTradeType === "rfq";

  return {
    isMarket,
    isLimit,
    isRFQ,
    perpTradeType,
    setPerpTradeType,
  };
};
